export const DISTRIBUTION_IOS = 1;
export const DISTRIBUTION_ANDROID = 2;
export const DISTRIBUTION_FREE = 3;
export const DISTRIBUTION_WEB = 4;
export const USE_QUALITY_CHECK = 5;
export const USE_WHITE_CHOCOLATE = 6;
export const USE_BOARD_POSTING = 7;
export const USE_BOARD_MESSAGING = 8;

export class PointHistory {
  name: string;
  point: number;
  distribution: number;
  created_at: Date;

  constructor(fields: any) {
    for (const f in fields) {
      this[f] = fields[f];
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/point-history.ts